export const SHOW_SUPPORT_GET_PARAM = 'contact_support';

enum ContactSupportMessages {
  STANDARD_ZERO = 'standard_zero',
  PRO_ZERO = 'pro_zero',
  STARTER_ZERO = 'starter_zero',
  GROWTH_ZERO = 'growth_zero',
  GROWTH_STARTER = 'growth_starter',
}

export const PrefilledMessages: Record<ContactSupportMessages, string> = {
  [ContactSupportMessages.STANDARD_ZERO]: 'I stopped streaming and no longer need premium features:\n' +
  '❌ Unlimited broadcasting;\n' +
  '❌ Multi-streaming;\n' +
  '❌ Custom Branding;\n' +
  '❌ Multiple Guests;\n' +
  '❌ Live Sales;\n' +
  '❌ HD Download, etc.\n' +
  'Please, cancel my Standard+ plan.',
  [ContactSupportMessages.PRO_ZERO]: 'I stopped streaming and no longer need premium features:\n' +
  '❌ Unlimited Broadcasts;\n' +
  '❌ Full HD quality;\n' +
  '❌ Multi-streaming;\n' +
  '❌ Custom Branding;\n' +
  '❌ Multiple Guests;\n' +
  '❌ Multi-camera;\n' +
  '❌ HD Download, etc.\n' +
  'Please, cancel my Pro plan.',
  [ContactSupportMessages.STARTER_ZERO]: 'I stopped streaming and no longer need premium features:\n' +
  '❌ 7 broadcasts per month;\n' +
  '❌ Multi-streaming;\n' +
  '❌ Custom Branding;\n' +
  '❌ Multiple Guests;\n' +
  '❌ 30 days storage;\n' +
  '❌ HD Download, etc.\n' +
  'Please, cancel my Starter plan.',
  [ContactSupportMessages.GROWTH_ZERO]: 'I stopped streaming and no longer need premium features:\n' +
  '❌ Live Sales Academy \n' +
  '❌ Unlimited Broadcasts;\n' +
  '❌ Post-show analytics;\n' +
  '❌ Multi-streaming;\n' +
  '❌ Multi-camera;\n' +
  '❌ 90 days storage;\n' +
  '❌ Repurposing, etc.\n' +
  'Please, cancel my Growth plan.',
  [ContactSupportMessages.GROWTH_STARTER]: 'I no longer need these features:\n' +
  '❌ Live Sales Academy \n' +
  '❌ Unlimited Broadcasts;\n' +
  '❌ Post-show analytics;\n' +
  '❌ Multi-camera;\n' +
  '❌ 90 days storage;\n' +
  '❌ Repurposing, etc.\n' +
  'Please, downgrade my Growth plan to Starter.',
};